import type { TRegionDetail } from '@src/server-side/api/fetch-region-details'

const makeRegionDetailsData = () => {
  let regionDetails: TRegionDetail | null = null

  const updateRegionDetails = (newRegionDetails: TRegionDetail) => {
    regionDetails = newRegionDetails
  }

  return Object.freeze({
    getRegionDetails: () => regionDetails,
    updateRegionDetails: updateRegionDetails,
  })
}

const regionDetailsHolder = makeRegionDetailsData()

export default regionDetailsHolder
